import { CommonModule } from '@angular/common'
import {
  Component,
  computed,
  EventEmitter,
  input,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core'
import { environment } from '@env/environment'

@Component({
  selector: 'app-popup-success',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './popup-success.component.html',
  styleUrl: './popup-success.component.sass',
})
export class PopupSuccessComponent implements OnChanges {
  @Input() show = false
  svg = input.required<string>()
  title = input.required<string>()

  @Output() onHide = new EventEmitter<boolean>()

  svgUrl = computed(() => `assets/rush/popup/${this.svg()}`)

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['show']) {
      setTimeout(() => {
        this.show = false
        this.onHide.emit(false)
      }, environment.popupDuration)
    }
  }
}
